import {classNames, pluralize, React, observer, _} from '@api'
import {Switch, Tooltip, Typography} from '@material-ui/core'
import {Apps, Settings, ViewHeadline} from '@material-ui/icons'
import {openInNewTab} from '@modules'
import * as css from './CatalogItemsList.css'
import {useCatalogItemsListStore} from './'
import {isTagField} from '@stores'
import {PrimaryIconButton, SearchField2} from 'centric-ui-components'
import {removeUndefinedsNested} from '@utils'
import {AddIcon} from '@stores/ui'
import {Tooltip2} from '@api'

export const CatalogItemsListToolbar = observer(function CatalogItemsListToolbar() {
  const store = useCatalogItemsListStore(),
    {
      strings, props: {titleStyle}, catalogField, setSearchRef, searchField, count, onClickAdd, searching, onSearch, label, library, isCreating, isUpdating, isEditMode, toggleEditLibraryMode, libraryWorkspace,
      sidebar: {searchText, libraryView, toggleView}, navigateToBoard, lastCount, tempSearchText, assignableField,
      stores: {
        sidebar: {left, left: {assignToCandidateOnly}}, nav, catalog, site
      },
      catalog: {searchActive},
      flexLayout: {create: {newCatalogTab}}
    } = store,
    id = catalog.focusedCatalogItemId
  // {urlForWorkspace} = nav,
  // workspace = left?.associatedWorkspace,
  // queryParams = nav.queryParamsFor(removeUndefinedsNested({itemId: catalog.parseIdFromPath(id)}) ?? {}),
  // urlInSidebar = urlForWorkspace({workspace, queryParams: {...queryParams, ...catalog.queryParamsFor({detailLoc: 'sidebar'})}}, true)

  if (lastCount !== null || count !== null || searchActive || searching) {
    return (
      <div className={css.toolbar} data-type='toolbar'>
        <Typography
          variant={'body1'}
          data-search-active={searchActive}
          className={classNames(css.body2, searchActive && css.hidden)} data-style={titleStyle}>
          {titleStyle == 'count' && (count !== null || lastCount !== null) ? `${count ?? lastCount ?? strings.emptyLabel} ${pluralize(strings.item, count ?? lastCount)}` : label}
        </Typography>
        <SearchField2
          ref={setSearchRef}
          className={classNames(css.searchField, {[css.shortSearchField]: library?.changeAssignTypeSwitch === true})}
          smallSearchInput
          value={tempSearchText ?? searchText}
          loading={searching}
          onSearch={onSearch}
          placeholder={`Search ${label}...`}/>

        {library?.changeAssignTypeSwitch === true &&
		 <Tooltip2 position='bottom' content={strings.assignAsArticleCandidate}>
			 <Switch
				 checked={left.assignToCandidateOnly}
				 onChange={() => left.assignToCandidateOnly = !assignToCandidateOnly}
				 name='toggleStyleCandidatesAssignment'
			 />
		 </Tooltip2>}

        {(libraryWorkspace?.visible || isTagField(catalogField)) &&
		 <PrimaryIconButton
			 icon={<Settings/>}
			 tooltip={`${strings.manage}`}
			 data-search-active={searchActive}
			 data-action='manageLibrary'
			 active={isEditMode}
			 className={classNames(searchActive && css.hidden, css.apps)}
			 onClick={() => {
               if (isTagField(catalogField)) {
                 toggleEditLibraryMode()
               } else {
                 // todo - in the future any filters should be copied into the new tabs config
                 newCatalogTab({workspace: libraryWorkspace, selectNewTab: true})
               }
             }}
		 />}

        {((!_.isBoolean(assignableField?.showAsLibrary) && assignableField?.showAsLibrary?.renderer === 'card' && !library?.renderer) || library?.renderer == 'card') &&
		 <PrimaryIconButton
			 onClick={toggleView}
			 tooltip={`${strings.switchTo} ${libraryView == 'card' ? strings.cardView : strings.listView}`}
			 data-action='toggleView'
           //active={libraryView == 'card'}
			 icon={libraryView == 'list' ? <ViewHeadline/> : <Apps/>}
			 className={classNames(searchActive && css.hidden, css.apps)}
		 />}


        {(library?.editable || isTagField(assignableField ?? catalogField)) &&
		 <PrimaryIconButton aria-label='SingleCreate'
		                    active={isCreating}
		                    tooltip={`${strings.add} ${label}`}
		                    disabled={isUpdating}
		                    onClick={onClickAdd}
		                    data-action='addLibraryItem'
		                    className={classNames(searchActive && css.hidden, css.createButton, css.apps)}>
			 <AddIcon/>
		 </PrimaryIconButton>
        }
      </div>
    )
  }
  return null
})



// WEBPACK FOOTER //
// ./src/modules/catalog/sidebar/CatalogItemsList/CatalogItemsListToolbar.tsx